import { Directive, Input, ElementRef, OnInit, Renderer2 } from '@angular/core';

/**
 * @description Directive used for setting background svg to current element
 * @example <div gasBgIcon="notifications-warning-bg">Some content</div>
 */
@Directive({
  selector: '[gasBgIcon]',
})
export class GasBgIconDirective implements OnInit {
  @Input('gasBgIcon')
  public iconName: string;

  @Input('gasBgIconSize')
  public iconSize: number;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) { }

  public ngOnInit(): void {
    /** Getting svg in current document */
    const svgHtml = document?.querySelector(`symbol#${this.iconName}`)?.outerHTML;

    if (!svgHtml) {
      return;
    }

    const currentSvg = svgHtml
      /** Remove all double quotes */
      .replace(/"/g, '\'')
      /** Replace symbol to svg, because symbol not works as background */
      .replace(/symbol/g, 'svg');

    if (!currentSvg) {
      throw new Error(`Not found svg "${this.iconName}" in document`);
    }

    /** Encode string with svg */
    const encodedSvg = window.btoa(currentSvg);
    const element: HTMLElement = this.elementRef.nativeElement;

    /** Set background style */
    this.renderer.setStyle(
      element,
      'backgroundImage',
      `url('data:image/svg+xml;base64,${encodedSvg}')`,
    );

    /** Set background size */
    if (this.iconSize) {
      this.renderer.setStyle(
        element,
        'backgroundSize',
        `${this.iconSize.toString()}px`,
      );
    }
  }
}
